import { useState } from 'react';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { OnboardingStepContainer } from './components/OnboardingStepContainer';
import { OnboardingStepHeader } from './components/OnboardingStepHeader';
import { SubscriptionPageContainer } from '../Subscription/SubscriptionPageContainer';

const STRINGS = appStrings.modules.subscription.subscriptionPlans;

type SubscriptionStepProps = Readonly<{
  onSubscriptionSuccess: () => void;
  onBasicPlanContinue: () => void;
}>;

export const SubscriptionStep = ({
  onSubscriptionSuccess,
  onBasicPlanContinue,
}: SubscriptionStepProps) => {
  const [isShowingCheckout, setIsShowingCheckout] = useState(false);

  return (
    <OnboardingStepContainer>
      {!isShowingCheckout && (
        <OnboardingStepHeader
          iconName="Tag01"
          title={STRINGS.selectPlan}
          subtitle={STRINGS.chooseBestPlan}
        />
      )}
      <SubscriptionPageContainer
        onPaymentSuccess={onSubscriptionSuccess}
        onBasicPlanContinue={onBasicPlanContinue}
        subscriptionView="ONBOARDING"
        onCheckoutViewChange={setIsShowingCheckout}
      />
    </OnboardingStepContainer>
  );
};
